import type { PoolCertificateInfoResultModel } from '@urbanx/agx.pools.client';

import { CertificateInfo, DocumentTypes } from '@urbanx/agx-ui-components';

export const toCertificateInfo = (
  certificate?: PoolCertificateInfoResultModel
): CertificateInfo | undefined => {
  if (!certificate) return undefined;
  if (!certificate.document)
    return {
      expiryDateExclusive: certificate.expiryDateExclusive,
    };

  const {
    documentId,
    containerFilePath,
    publicPath,
    fileName,
    fileSizeInBytes,
    documentType,
    containerName,
    dateUploaded,
  } = certificate.document;

  const uiDocumentType = Object.values(DocumentTypes).find(
    (value) => value.toString() === documentType?.toString()
  );

  if (
    !documentId ||
    !containerFilePath ||
    !fileName ||
    fileSizeInBytes === undefined ||
    !uiDocumentType ||
    !containerName
  ) {
    const missingFields = [
      !documentId && 'documentId',
      !containerFilePath && 'containerFilePath',
      !fileName && 'fileName',
      fileSizeInBytes === undefined && 'fileSizeInBytes',
      !uiDocumentType && 'documentType',
      !containerName && 'containerName',
    ].filter(Boolean);

    throw new Error(
      `The Pools API returned an incomplete certificate document. Missing or invalid fields: ${missingFields.join(', ')}.`
    );
  }

  return {
    expiryDateExclusive: certificate.expiryDateExclusive,
    document: {
      documentId,
      containerFilePath,
      publicPath,
      fileName,
      fileSizeInBytes,
      documentType: uiDocumentType,
      containerName,
      dateUploaded,
    },
  };
};
